import { useEffect, useState } from 'react';

/**
 * Whether the mgt people picker with this id holds typed text that has not been picked from its list - a form keeps its
 * Save / Create / Update off while it does, or the text is silently dropped (Shaun, 2026-10-22). The picker's input is
 * in its shadow root; these events reach the document retargeted to the picker, and a pick (click or Enter) clears it.
 */
export const usePeoplePickerTyped = (id: string): boolean => {
  const [typed, setTyped] = useState(false);

  useEffect(() => {
    const read = () => {
      const picker: any = document.getElementById(id);
      setTyped(((picker?.userInput as string) ?? '').trim() !== '');
    };
    // One read waiting at a time, and none left behind once the form has gone.
    let pending: number | undefined;
    const later = () => {
      window.clearTimeout(pending);
      pending = window.setTimeout(read);
    };
    const events = ['input', 'keyup', 'click', 'focusout'];
    events.forEach(e => document.addEventListener(e, later, true));
    return () => {
      window.clearTimeout(pending);
      events.forEach(e => document.removeEventListener(e, later, true));
    };
  }, [id]);

  return typed;
};
